/** @format */

import { useDispatch, useSelector } from "react-redux";
import { imgUrl } from "../store/api";
import { setServiceCatIDS, setEdit, setDelete } from "../store/service";
import { showChildService, showDeleteModal } from "../store/stateSlice";
import DeleteModal from "../components/pops/global modals/deleteModal";

//import assets
import DummyImage from "../Assets/images/dummy-image-square.jpg";
import { useState } from "react";

export const ServiceCard = ({ from, key, item, getAllServices }) => {
  const [id, setId] = useState();
  const dispatch = useDispatch();
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);

  // function to show delete Modal
  const handleDeleteModal = (serviceID, categoryID) => {
    setId(serviceID);
    // dispatch(setServiceCatIDS({ serviceID, categoryID }));
    dispatch(setEdit({ edit: false }));
    dispatch(setDelete({ delete: true }));
    dispatch(showDeleteModal());
  };

  const handleAddService = (serviceID, categoryID) => {
    dispatch(setServiceCatIDS({ serviceID, categoryID }));
    dispatch(setEdit({ edit: true }));
    dispatch(setDelete({ delete: false }));
    dispatch(showChildService());
  };

  const service = useSelector((state) => state.service);
  return (
    <>
      {service.delete && (
        <DeleteModal
          from='service'
          getAllServices={getAllServices}
          id={item.id}
        />
      )}

      <div
        className={`service-card ${from === "order-history" ? "flex-3" : ""}`}
        style={{
          borderBottom: `5px solid #${randomColor ? randomColor : "FF8900"}`,
        }}
        key={key}>
        <img
          src={item?.image ? imgUrl + item.image : DummyImage}
          alt='service '
          className='service-card__img'
        />

        {from === "service-domains" ? (
          <div className='services-domains__col'>
            <p>{item.name_ar}</p>
            <div>
              <p className='services-domains__buttons'>
                <p
                  className='services-domains__edit'
                  onClick={() => handleAddService(item.id, item.category_id)}>
                  تعديل
                </p>
                <p
                  className='services-domains__delete'
                  onClick={() => handleDeleteModal(item.id, item.category_id)}>
                  حذف
                </p>
              </p>
            </div>
          </div>
        ) : (
          <div className='service-card__text'>
            <p>{item.name_ar}</p>
            <p className='text--primary'>
              <b>{item.count}</b> طلب
            </p>
          </div>
        )}
      </div>
    </>
  );
};
